import React, { useEffect } from 'react';
import { Grid, Typography, Card, CardContent, Box } from '@mui/material';
import { styles } from './styles';
import PositionStatusGraph from './PositionStatusGraph';
import PositionMappedGraph from './PositionMappedGraph';
import { ChangeRequestsGraph } from './ChangeRequestsGraph';
import {
    useGetPositionMappingSummaryByStatusMutation,
    useGetRecruitmentPolicySummaryMutation,
} from '../../api/dashboard';

const Dashboard = (props) => {
    const [getPositionMappingSummaryByStatus, { data: positionMappingData, isLoading: isPositionMappingLoading }] =
        useGetPositionMappingSummaryByStatusMutation();
    const [getRecruitmentPolicySummary, { data: recruitmentPolicyData, isLoading: isRecruitmentPolicyLoading }] =
        useGetRecruitmentPolicySummaryMutation();

    const loading = isPositionMappingLoading || isRecruitmentPolicyLoading;

    useEffect(() => {
        const fetchDashboardData = async () => {
            try {
                await Promise.all([
                    getPositionMappingSummaryByStatus().unwrap(),
                    getRecruitmentPolicySummary().unwrap(),
                ]);
            } catch (error) {
                console.error('Error fetching dashboard data:', error);
            }
        };

        fetchDashboardData();
    }, []);

    return (
        <Box>
            <Box sx={styles.contentHeaderWrapper}>
                <Typography variant="h4">Dashboard</Typography>
            </Box>
            <Box sx={styles.contentBodyWrapper}>
                <Card>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item md={12} xs={12}>
                                <PositionStatusGraph />
                            </Grid>
                            <Grid item md={6} xs={6}>
                                <PositionMappedGraph
                                    data={positionMappingData}
                                    title={'Position with Change Policies'}
                                />
                            </Grid>
                            <Grid item md={6} xs={6}>
                                <PositionMappedGraph
                                    data={recruitmentPolicyData}
                                    title={'Positions with Recruitment Policies'}
                                />
                            </Grid>
                            <Grid item md={6} xs={6}>
                                <ChangeRequestsGraph />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default Dashboard;
